export const MATERIAL_TRANSACTION_TYPE = [
  {
    name: 'ซื้อ',
    direction: 'buy',
  },
  {
    name: 'ขาย',
    direction: 'sell',
  },
];
export default MATERIAL_TRANSACTION_TYPE;
